var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonWithFeedback',{staticClass:"btn btn--primary square-button",class:{'btn--ghost': _vm.ghost, 'disabled': _vm.disabled},on:{"click":_vm.handleClick}},[(!this.label)?_vm._t("default"):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.label))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }